import React from "react";
import { CircularProgress } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import MaterialCheckbox from "../../../styles/materialCheckbox";
import { StyledCheckbox } from "../../../styles/styledTabsForm";
import { StyledTelegramPairSelector } from "../../styledTelegramBot";

export const togglePair = (pairs, currencyId, paymentSystemId) => {
  const exists = pairs.some(p => p.currencyId === currencyId && p.paymentSystemId === paymentSystemId);
  return exists
    ? pairs.filter(p => !(p.currencyId === currencyId && p.paymentSystemId === paymentSystemId))
    : [...pairs, { currencyId, paymentSystemId }];
};

export const isPairSelected = (pairs, currencyId, paymentSystemId) =>
  pairs.some(p => p.currencyId === currencyId && p.paymentSystemId === paymentSystemId);

const TelegramPairSelector = ({ available, selected, onToggle, loading, t }) => {
  if (loading) return <CircularProgress size={20} />;
  if (available.length === 0) return <Alert severity="warning">{t("connections.dialog.noPairs")}</Alert>;

  return (
    <StyledTelegramPairSelector className="tg-pair-selector">
      {available.map((pair, i) => {
        const cId = pair.currency?.asset;
        const psId = pair.paymentSystem?.subName;
        return (
          <label key={i} className="tg-pair-selector__row test">
            <StyledCheckbox position="center">
              <MaterialCheckbox
                checked={isPairSelected(selected, cId, psId)}
                onChange={() => onToggle(cId, psId)}
              />
            </StyledCheckbox>
            <span className="tg-pair-selector__label">{cId} / {psId}</span>
          </label>
        );
      })}
    </StyledTelegramPairSelector>
  );
};

export default TelegramPairSelector;